import bearerTokenReducer from './bearerTokenSlice';
import clientIDReducer from './clientIDSlice';
import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { connectRouter, routerMiddleware } from 'connected-react-router';
import history from './history'
import thunk from 'redux-thunk';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
 

const reducers = {
    bearerToken: bearerTokenReducer,
    clientID: clientIDReducer
}

const rootReducer = combineReducers({
    ...reducers,
    router: connectRouter(history)
});

const middleware = [
    thunk,
    routerMiddleware(history)
];

const store = configureStore({
    reducer: rootReducer,
    middleware: middleware,
    devTools: true
  });
  

export default store;

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;